import {} from "../edge/index.js";
import { createHalfEdgeId } from "../half-edge/createHalfEdgeId.js";
import {} from "../half-edge/index.js";
import {} from "../net/index.js";
export function addEdge(net) {
    const firstId = createHalfEdgeId();
    const firstHalfEdgeEntry = { id: firstId };
    const secondId = createHalfEdgeId();
    const secondHalfEdgeEntry = { id: secondId };
    const firstHalfEdge = {
        "@type": "Value",
        "@kind": "HalfEdge",
        id: firstId,
    };
    const secondHalfEdge = {
        "@type": "Value",
        "@kind": "HalfEdge",
        id: secondId,
    };
    firstHalfEdgeEntry.otherHalfEdge = secondHalfEdge;
    secondHalfEdgeEntry.otherHalfEdge = firstHalfEdge;
    net.halfEdgeEntries.set(firstId, firstHalfEdgeEntry);
    net.halfEdgeEntries.set(secondId, secondHalfEdgeEntry);
    return {
        first: firstHalfEdge,
        second: secondHalfEdge,
    };
}
//# sourceMappingURL=addEdge.js.map